import React, { useEffect, useState } from 'react';

import css from './QuoteDossier.module.css';
import { UrlParam } from '../../../shared/dossier';
import useQuote from '../../../hooks/useQuote';
import useNavigation from '../../../hooks/useNavigation';
import NewLoadingState from '../NewLoadingState/NewLoadingState';
import DossierHeader from '../../../../components/DossierHeader/DossierHeader';
import DossierTitle from '../DossierTitle/DossierHeader';
import { BaseCard } from '../../Cards/BaseCard/BaseCard';
import EntityPill from '../../../../components/EntityPill/EntityPill';
import EventPill from '../../EventPill/EventPill';
import AiBadge from '../../AiBadge/AiBadge';

function QuoteDossier({ size, quoteId, onSizeChange }) {
  const { quote, loading } = useQuote(quoteId);
  const { params, navigate, location } = useNavigation();

  const onPillClicked = (entity) => {
    params.delete('dossierEventId');
    params.delete('viewQuote');
    params.set('dossierEntityId', entity.id);
    params.set('dossierType', 'entity');
    navigate(location.pathname, params, { back: `Back to Quote` });
  };

  if (loading) return <NewLoadingState />;
  if (!quote) return null;

  return (
    <div className={css.main}>
      <div className={css.header}>
        <DossierHeader size={size} onSizeChange={onSizeChange} />
        <div
          style={{ marginTop: -5, zIndex: 5, position: 'relative' }}
          className={css.divider}
        />
      </div>
      <div className={css.content}>
        <DossierTitle>Quote</DossierTitle>
        <h2 className={css.headline}> {`"${quote.quote}"`}</h2>
        <BaseCard.InfoColumn title="Quote by">
          <EntityPill
            id={quote.speaker.id}
            image={quote.speaker.image}
            name={quote.speaker.name}
            shortName={quote.speaker.shortestName}
            tooltip={quote.speaker.tooltip}
            type={quote.speaker.type}
            isConnected={quote.speaker.isConnected}
            inSubscription={quote.speaker.inSubscription}
            onClick={() => onPillClicked(quote.speaker)}
            size="small"
          />
        </BaseCard.InfoColumn>

        <BaseCard.InfoColumn title="Event">
          <EventPill id={quote.event.id} title={quote.event.title} />
        </BaseCard.InfoColumn>

        <BaseCard.InfoColumn
          title={
            <div className={css.context}>
              Context <AiBadge />
            </div>
          }
        >
          {quote.context}
        </BaseCard.InfoColumn>

        <BaseCard.InfoColumn title="Industries">
          <BaseCard.BriefPillList briefs={quote.industries} />
        </BaseCard.InfoColumn>

        <BaseCard.InfoColumn title="Countries">
          <BaseCard.BriefPillList briefs={quote.countries} isGeography />
        </BaseCard.InfoColumn>
      </div>
      <div className={css.divider} />
    </div>
  );
}

export default function QuoteDossierWrapper({ size, onSizeChange }) {
  const [isDossierOpen, setIsDossierOpen] = useState(false);
  const { params } = useNavigation();

  useEffect(() => {
    const dossierQuoteId = params.get(UrlParam.quoteId);
    const dossierType = params.get('dossierType');

    if (dossierQuoteId && dossierType) {
      setIsDossierOpen(true);
    } else {
      setIsDossierOpen(false);
    }
  }, [params]);

  if (!isDossierOpen) return null;

  return (
    <QuoteDossier
      size={size}
      quoteId={params.get(UrlParam.quoteId)}
      onSizeChange={onSizeChange}
    />
  );
}
